<section class="title-bar content-padding first-item">
  <div class="wrapper nowrap">
    <h2 class="title-heading">{{productCategory?.id ? "Modifica" : "Nuovo"}} Categoria di Prodotti</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
      </span>
    </div>
  </div>
</section>

<section class="content-padding darker">
  <div class="narrow-wrapper">
    <form class="has-cols" [formGroup]="productCategoryForm" (ngSubmit)="onSubmit()">
      <div class="basic-info-box" style="margin-top: 15px;">
        <fieldset>
          <legend>BASIC INFO:</legend>
          <div class="col-50 grid-element">
            <label for="name">Nome Categoria*</label>
            <input type="text" name="name" formControlName="categoryName">
            <app-error-html-handler [ctrl]="productCategoryForm.get('categoryName')" [messages]="formValidationMsgs.categoryName"></app-error-html-handler>
          </div>
          
          <div class="col-50 grid-element">
              <label for="sku">Note</label>
              <textarea formControlName="notes" rows="5" placeholder="Scrivi una descrizione"></textarea>
          </div>
        </fieldset>
      </div>

      <div class="ai-prompt" style="margin-top: 15px;">
        <fieldset>
          <legend>AI PROMPT:</legend>
          <div class="col-50 grid-element-full">
            <label for="sku">PROMPT</label>
            <textarea formControlName="aiPrompt" rows="3" placeholder="scrivi il prompt"></textarea>
          </div>
        </fieldset>
      </div>

      <div class="expert-personal-info" style="margin-top: 15px;">
        <fieldset>
          <legend>EXTRA FIELDS:</legend>
          <div class="grid-element-full mt-5">
            <div formArrayName="categoryMetaFields">
              <div class="offer-products" *ngFor="let metaField of productCategoryForm.get('categoryMetaFields').controls; let i = index">
                <div class="mb-5 date__time-section" style="display: flex; width: 100%; align-items: flex-end; gap: 15px;">
                  <div class="product-q" [formGroupName]="i">
                    <div class="porduct-qty flexnowrap" style="gap: 16px;">
                      <div style="position: relative; cursor: pointer;">
                        <i (click)="removeCategoryMetaField(i)" class="far fa-times-circle hvr-grow remove-product"
                          style="position: absolute; top: 50%; left: -4px;">
                        </i>
                      </div>
                      <div class="parent-form-group">
                        <div class="saifu-input">
                          <label for="">Field Name</label>
                          <input type="text" formControlName="fieldName">
                          <app-error-html-handler [ctrl]="metaField.get('fieldName')" [messages]="formValidationMsgs.categoryMetaFields.fieldName"></app-error-html-handler>
                        </div>
                        <div class="saifu-input">
                          <label for="">Type</label>
                          <select formControlName="type">
                            <option value="0">Optional</option>
                            <option value="1">Required</option>
                            <option value="3">Admin</option>
                          </select>
                          <app-error-html-handler [ctrl]="metaField.get('type')" [messages]="formValidationMsgs.categoryMetaFields.type"></app-error-html-handler>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="center" style="width: 100%;">
              <button class="btn mt-0" (click)="$event.preventDefault(); addCategoryMetaField()">
                Aggiungi Field<i class="ml-10 fas fa-plus"></i>
              </button>
            </div>
            
          </div>
        </fieldset>
        <br class="clear">
      </div>

      <div class="valet-province">
        <fieldset>
          <legend>PROVINCE DISCOUNTS:</legend>
          <div class="grid-element-full">
            <div formArrayName="provinceDiscounts">
              <div class="offer-products" *ngFor="let provinceDiscountForm of productCategoryForm.get('provinceDiscounts').controls; let i = index">
                <fieldset style="margin-bottom: 15px;">
                  <legend></legend>
                  <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                    <label for=""></label>
                    <div style="display: table-cell; width: 19px;">
                      <i class="far fa-times-circle hvr-grow remove-province"  (click)="removeProvince(i)"></i>
                    </div>
                    <div class="province-product-q">
                      <div class="province-porduct-qty">
  
                        <div class="saifu-input" formGroupName="province">
                          <label for="">Province</label>
                            <ng-select formControlName="id">
                            <ng-option *ngFor="let province of provinces" [value]="province.id" [disabled]="isProvinceOptionDisabled(province)">
                              <b>{{ province?.provinceCode }}</b> {{ province?.province }}
                            </ng-option>
                          </ng-select>
                        </div>
                        <div class="saifu-input">
                          <label for="">Discount %</label>
                          <input type="text" placeholder="" formControlName="discount">
                          <app-error-html-handler [ctrl]="provinceDiscountForm?.controls?.discount" [messages]="formValidationMsgs?.provinceDiscounts?.discount"></app-error-html-handler>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <div class="center" style="width: 100%; margin-top: 15px;">
              <button class="btn mt-0" (click)="$event.preventDefault(); addProvince()">
                Aggiungi Province<i class="ml-10 fas fa-plus"></i>
              </button>
            </div>
          </div>
        </fieldset>
        <br class="clear">
      </div>
      <div class="center" style="margin-top: 10px;">
        <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled]="!productCategoryForm.valid">
          Salva<i class="ml-10 far fa-save"></i>
        </button>
      </div>
      
    </form>
    <br class="clear">
  </div>
</section>